import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Rewiring', href: '/rewiring' },
    { name: 'Services', href: '/services' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Projects', href: '/projects' },
    { name: 'Landlords', href: '/landlords' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50 border-b border-gray-200">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_landlord-safety-1/artifacts/ez010v5h_crescent.JPG"
              alt="Crescent Electrical Ltd"
              className="h-14 w-auto"
            />
            <span className="text-gray-900 font-bold text-xl hidden sm:block">Crescent Electrical</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                  isActive(item.href) ? 'text-blue-600' : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex lg:items-center lg:gap-3">
            <a href={`https://wa.me/447711233685`} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" size="sm" className="gap-2">
                <MessageCircle className="h-4 w-4" />
                WhatsApp
              </Button>
            </a>
            <a href={`tel:${companyInfo.phone}`}>
              <Button size="sm" className="gap-2 bg-blue-600 hover:bg-blue-700">
                <Phone className="h-4 w-4" />
                {companyInfo.phone}
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden rounded-md p-2 text-gray-700 hover:text-[#F97316] hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 pb-4">
            <div className="space-y-1 pt-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block px-4 py-3 text-base font-medium rounded-md transition-colors mx-4 ${
                    isActive(item.href)
                      ? 'bg-orange-50 text-[#F97316]'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <div className="mt-4 px-4 space-y-2">
              <a 
                href={`tel:${companyInfo.phone}`} 
                className="block"
              >
                <Button variant="outline" className="w-full gap-2 border-2 border-[#2563EB] text-[#2563EB] hover:bg-blue-50">
                  <Phone className="h-4 w-4" />
                  {companyInfo.phone}
                </Button>
              </a>
              <Link to="/rewire-quote" className="block" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white shadow-md">
                  GET A QUOTE
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
